import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { RootState } from '@store/store';
import { services } from '@services/api';

export function useCanSeeDims() {
  const { user } = useSelector((state: RootState) => state.auth);
  const isAdmin = (user?.permissions || []).includes('system:admin');
  const userId = user?.id;

  const { data: myMemberships, isLoading } = useQuery({
    queryKey: ['my-group-memberships', userId],
    queryFn: async () => {
      const res = await services.auth.getMyGroupMemberships();
      return res.data;
    },
    enabled: !isAdmin && !!userId,
    staleTime: Infinity,
  });

  if (isAdmin) return { canSeeDims: true, isLoading: false };
  if (!userId) return { canSeeDims: false, isLoading: true };

  const userGroups = myMemberships?.map((g: { name: string }) => g.name) || [];
  return { canSeeDims: userGroups.includes('Dims_C'), isLoading };
}
